import { ApolloError } from '@apollo/client';

import { useErpCareerDashboardQuery } from 'core/graphql';

import { useStableRefetch } from '../Groups/useStableRefetch';
import { ICareerDashboard } from './careerModel';

interface ICareerDashboardHook {
  dashboard?: ICareerDashboard;
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
}

/**
 * Spec 0018 increment B — the Дашборд tab (`careerDashboard`). One request for
 * the whole funnel (members → trained → profileReady → applied → placed) plus
 * `vacanciesPublished`. Re-fetched after a placement is recorded so the counts
 * stay in step with the Участники tab.
 */
export const useCareerDashboard = (): ICareerDashboardHook => {
  const { data, loading, error, refetch } = useErpCareerDashboardQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const stableRefetch = useStableRefetch(refetch);

  return {
    dashboard: data?.careerDashboard,
    loading,
    error,
    refetch: stableRefetch,
  };
};
